import { CustomDayPicker } from '@components/DayPicker';
import dayjs from 'dayjs';
import TimePicker from '@components/timePicker';
import { hr } from 'date-fns/locale';

export const DayPickerLocale: any = {
    hr: hr,
    en: undefined,
    sr: undefined,
};

interface DateTimeSelectorProps {
    dateTimePickHandler: (timestamp: number) => void;
    disabledBefore?: any;
    disabledAfter?: any;
    readOnly?: boolean;
    value: number;
}

function DateTimeSelector(props: DateTimeSelectorProps) {
    const { readOnly = false, value, disabledBefore = {}, disabledAfter = {}, dateTimePickHandler } = props;

    const handleTimeChange = (time: any) => {
        if (time) {
            const base = dayjs(value);
            const selection = base.hour(time.hour()).minute(time.minute()).second(time.second())?.valueOf();

            if (dateTimePickHandler) {
                dateTimePickHandler(selection);
            }
        }
    };

    const handleDateChange = (pick: any) => {
        let selection = pick.getTime();
        let selectionDate = new Date(selection);
        let prevSelectedDate = new Date(value);
        let beginingOfDay = new Date(selectionDate.getFullYear(), selectionDate.getMonth(), selectionDate.getDate());
        let previousBeginingOfDay = new Date(
            prevSelectedDate.getFullYear(),
            prevSelectedDate.getMonth(),
            prevSelectedDate.getDate()
        );
        let prevSelectionTimeMs = prevSelectedDate.getTime() - previousBeginingOfDay.getTime();
        let selectionWithPreservedTime = beginingOfDay.getTime() + prevSelectionTimeMs;
        if (dateTimePickHandler) {
            dateTimePickHandler(selectionWithPreservedTime);
        }
    };

    if (value === undefined) {
        return <div>Missing value timestamp</div>;
    }

    return (
        <div className="display-flex ">
            {!readOnly ? (
                <div className="flex mb-8p" style={{ fontSize: '16px' }}>
                    <CustomDayPicker
                        value={new Date(value)?.getTime()}
                        onSelect={handleDateChange}
                        disabledBefore={disabledBefore}
                        disabledAfter={disabledAfter}
                        disabled={readOnly}
                    />
                </div>
            ) : (
                <div className="flex mr-8p mb-8p mt-6p" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                    {dayjs(value).format('lll')}{' '}
                </div>
            )}

            {!readOnly ? (
                <div className="flex ml-8p mb-8p">
                    <TimePicker
                        value={value ? dayjs(value, 'HH:mm:ss') : null}
                        onChange={(time: any) => handleTimeChange(time)}
                        minuteStep={10}
                    />
                </div>
            ) : (
                <div className="col-3 p-0 mt-6p" style={{ fontWeight: 'bold' }}>
                    {dayjs(value).format('HH:mm')}
                </div>
            )}
        </div>
    );
}

export default DateTimeSelector;
